import React, { useMemo } from 'react';
import cx from 'classnames';
import Clipboard from 'react-clipboard.js';

export type ThemeFn = (
  props: Pick<CopyToClipboardButtonProp, 'active'>
) => Array<string | undefined | string[] | Record<string, boolean | undefined>>;

export const themes: Record<'default' | 'bgDark', ThemeFn> = {
  default: ({ active }) => [
    'hover:v2-text-yellow-500',
    {
      'v2-text-neutral-500': !active,
      '!v2-text-yellow-500': active,
    },
  ],
  bgDark: ({ active }) => [
    'hover:text-yellow-500',
    {
      'text-white': !active,
      'text-yellow-500': active,
    },
  ],
};

export interface CopyToClipboardButtonProp {
  clipboardText: string | undefined;
  className?: string;
  onClick?: () => void;
  onSuccess?: () => void;
  active?: boolean;
  theme?: ThemeFn;
}

export function CopyToClipboardButton({
  clipboardText,
  className,
  onClick,
  onSuccess,
  active,
  theme = themes.default,
}: CopyToClipboardButtonProp) {
  const themeClassNames = useMemo(() => theme({ active }), [active]);

  return (
    <Clipboard
      component='span'
      data-clipboard-text={clipboardText}
      onSuccess={() => {
        onSuccess?.();
      }}
      onClick={() => {
        onClick?.();
      }}
      className={cx(
        className,
        ['fas fa-paste absolute', 'cursor-pointer'],
        themeClassNames
      )}
    />
  );
}
